import { manifest } from "@parcel/service-worker";
import { version } from "../package.json";
//import defaultImg from "./public/default.png"; // can be jpg now / maybe can load QR code instead!

// Define cache version and assets to cache
export const MINOR_VERSION =
    process.env.PARCEL_COMMIT_HASH || new Date().toISOString().split("T")[0]; // 2025-11-11 // this will always trigger cache update on refresh ??
export const MAJOR_VERSION = "MAJOR_VERSION-" + version; // TODO: update version when need to redo; will also update dexie db

// Install event: Cache essential assets
self.addEventListener("install", (event: ExtendableEvent) => {
    event.waitUntil(
        caches
            .open(MINOR_VERSION)
            .then((cache) => {
                //manifest.push(defaultImg); // error bc duplicate add with jpg cach
                //const files = Array.from(new Set(manifest)); // ensure no duplicates bc of importing
                console.log("Caching files: ", manifest.join(", "));
                cache.addAll(manifest);
            })
            .then(() => self.skipWaiting())
            .finally(() => {
                console.log("Service Worker installed: ", MINOR_VERSION);
            })
    );

    // event.waitUntil(
    //     Promise.all([
    //         caches.open(MINOR_VERSION).then((cache) => {
    //             //manifest.push(defaultImg); // error bc duplicate add with jpg cach
    //             //const files = Array.from(new Set(manifest)); // ensure no duplicates bc of importing
    //             console.log("Caching files: ", manifest.join(", "));
    //             return cache.addAll(manifest);
    //         }),
    //         self.skipWaiting() // to activate right away
    //     ]).finally(() => {
    //         console.log("Service Worker installed: ", MINOR_VERSION);
    //     })
    // );
});

// self.addEventListener("activate", (event: ExtendableEvent) => {
//     event.waitUntil(
//         (async () => {
//             const cacheNames = await caches.keys();
//             await Promise.all(
//                 cacheNames.map((cache) => {
//                     if (cache !== MINOR_VERSION && cache !== MAJOR_VERSION) {
//                         return caches.delete(cache);
//                     }
//                 })
//             );
//             await self.clients.claim();

//             const clients = await self.clients.matchAll({ type: "window" });
//             for (const client of clients) {
//                 client.postMessage({ version: MINOR_VERSION });
//                 // 🔹 Optional auto reload once to ensure cached files load right away
//                 client.navigate(client.url);
//             }
//             console.log("Service Worker activated:", MINOR_VERSION);
//         })()
//     );
// });

// Activate event: Cleanup old caches
self.addEventListener("activate", (event: ExtendableEvent) => {
    event.waitUntil(
        Promise.all([
            // Handle cache deletion
            caches.keys().then((cacheNames) =>
                Promise.all(
                    cacheNames.map((cache) => {
                        if (
                            cache !== MINOR_VERSION &&
                            cache !== MAJOR_VERSION
                        ) {
                            console.log("Deleting old cache: ", cache);
                            return caches.delete(cache);
                        }
                    })
                )
            ),
            // to take control right away
            self.clients.claim().then(() => {
                self.clients.matchAll({ type: "window" }).then((clients) => {
                    clients.forEach((client) => {
                        client.postMessage({ version: MINOR_VERSION });
                    });
                });
            })
        ]).finally(() => {
            console.log("Service Worker activated");
        })
    );
});

self.addEventListener("fetch", (event: FetchEvent) => {
    event.respondWith(
        caches.match(event.request).then((cachedResponse) => {
            if (cachedResponse) {
                console.log("Serving from cache: ", event.request.url);
                return cachedResponse;
            } else {
                const start = performance.now();
                return fetch(event.request)
                    .then((networkResponse) => {
                        if (
                            networkResponse.status === 200 &&
                            event.request.method === "GET"
                        ) {
                            return caches
                                .open(
                                    event.request.url.endsWith(".jpg") ||
                                        event.request.url.endsWith("json")
                                        ? MAJOR_VERSION
                                        : MINOR_VERSION
                                )
                                .then((cache) => {
                                    cache.put(
                                        event.request,
                                        networkResponse.clone()
                                    );
                                    return networkResponse;
                                })
                                .finally(() => {
                                    if (event.request.url.endsWith(".jpg")) {
                                        console.log(
                                            "Caching new jpg: ",
                                            event.request.url
                                        );
                                    } else if (
                                        event.request.url.endsWith("json")
                                    ) {
                                        console.log(
                                            "Caching new json: ",
                                            event.request.url
                                        );
                                    } else {
                                        console.log(
                                            "Caching new url: ",
                                            event.request.url
                                        );
                                    }
                                });
                        } else {
                            return networkResponse;
                        }
                    })
                    .catch((error) => {
                        if (event.request.mode === "navigate") {
                            return caches
                                .match("/index.html")
                                .then(async (response) => {
                                    return new Response(
                                        (await response?.blob()) ??
                                            "Please connect to the internet. Then refresh page.",
                                        {
                                            status: 200,
                                            statusText:
                                                "No internet. Serving from cache: " +
                                                event.request.url,
                                            headers: {
                                                "Content-Type": "text/html"
                                            }
                                        }
                                    );
                                })
                                .finally(() => {
                                    console.warn(
                                        "No internet. Serving from cache: ",
                                        error.message
                                    );
                                });
                        } else {
                            // Let non-navigation requests fail naturally (browser offline behavior)
                            throw error;
                        }
                    })
                    .finally(() => {
                        const end = performance.now();
                        console.info(
                            `Fetch duration: ${end - start} ms for ${
                                event.request.url
                            }`
                        );
                    });
            }
        })
    );
});

// cache first strategy // network second
// Fetch event: Serve cached assets or fallback to network and cache it // image files at github!
// self.addEventListener("fetch", (event: FetchEvent) => {
//     event.respondWith(
//         caches.match(event.request).then((cachedResponse) => {
//             if (cachedResponse) {
//                 console.log("Serving from cache: ", event.request.url);
//                 return cachedResponse;
//             } else {
//                 const start = performance.now();
//                 return fetch(event.request)
//                     .then((networkResponse) => {
//                         if (
//                             networkResponse.status === 200 &&
//                             event.request.method === "GET" // cannot cache videos or post requests
//                         ) {
//                             return caches
//                                 .open(
//                                     event.request.url.endsWith(".jpg") ||
//                                         event.request.url.endsWith("json")
//                                         ? MAJOR_VERSION
//                                         : MINOR_VERSION
//                                 )
//                                 .then((cache) => {
//                                     cache.put(
//                                         event.request,
//                                         networkResponse.clone()
//                                     );
//                                     return networkResponse;
//                                 })
//                                 .finally(() => {
//                                     if (event.request.url.endsWith(".jpg")) {
//                                         console.log(
//                                             "Caching new jpg: ",
//                                             event.request.url
//                                         );
//                                     } else if (
//                                         event.request.url.endsWith("json")
//                                     ) {
//                                         console.log(
//                                             "Caching new json: ",
//                                             event.request.url
//                                         );
//                                     } else {
//                                         console.log(
//                                             "Caching new url: ",
//                                             event.request.url
//                                         );
//                                     }
//                                 });
//                         } else {
//                             return networkResponse;
//                         }
//                     })
//                     .catch((error) => {
//                         return caches
//                             .match("/index.html")
//                             .then(async (response) => {
//                                 return new Response(
//                                     (await response?.blob()) ??
//                                         "Please connect to the internet. Then refresh page.",
//                                     {
//                                         status: 200,
//                                         statusText:
//                                             "No internet. Serving from cache: " +
//                                             event.request.url,
//                                         headers: {
//                                             "Content-Type": "text/html"
//                                         }
//                                     }
//                                 );
//                             })
//                             .finally(() => {
//                                 console.warn(
//                                     "No internet. Serving from cache: ",
//                                     error.message
//                                 );
//                             });
//                     })
//                     .finally(() => {
//                         const end = performance.now();
//                         console.info(
//                             `Fetch duration: ${end - start} ms for ${
//                                 event.request.url
//                             }`
//                         );
//                     });
//             }
//         })
//     );
// });

// Optional: Background sync event
// self.addEventListener("sync", (event: SyncEvent) => {
//     if (event.tag === "sync-data") {
//         console.log("Syncing data...");
//         event.waitUntil(
//             // Perform background sync tasks here
//             fetch("/update-data-endpoint").then((response) => {
//                 console.log("Data synced successfully!", response);
//             })
//         );
//     }
// });

// Optional: Push notification event
// self.addEventListener("push", (event: PushEvent) => {
//     const data = event.data?.json();
//     if (data) {
//         self.registration.showNotification(data.title, {
//             body: data.message,
//             icon: "/icons/icon-192x192.png"
//         });
//     }
// });
